<template>
  <div class="product-no">
    <div>
      <el-form :model="dataForm" :rules="dataRules" ref="refForm" label-width="100px" inline>

        <el-form-item label="自定义产品编码" label-width="auto" prop="productNo">
          <el-input v-model="dataForm.productNo" size="small" placeholder="请输入自定义产品编码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" round icon="el-icon-setting" :class="'dis-btn'"
                     :disabled="isSeting" @click="onClickSubmit()">设置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
        :visible.sync="dialogVisible"
        title="提示"
        lock-scroll
        append-to-body
        width="435px"
        style="margin-top: 18vh;"
    >
      <span style="text-align:center;margin:20px;font-size: 16px;">请确认是否设置产品编码</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="updateProductNo()">
            确认
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import {
  getEnterprise,
  updateProductNo
} from "../../utils/interface";
import ProductInfo from "./reversoProductInfo";


export default {
  components: {
    ProductInfo,
  },
  data() {
    return {
      dataForm: {
        productNo: '',
        uuid: '',
      },
      dataRules: {
        productNo: [
          {required: true, message: '请输入自定义产品编码', trigger: 'change'},
          {pattern: '^[A-Z]{1,5}$', message: '请输入1-5位大写字母'}
        ],
      },
      isSeting: true,
      dialogVisible: false,
    };
  },
  created() {

  },
  methods: {
    initData() {
      this.getEnterprise()
    },
    getEnterprise() {
      getEnterprise().then((res) => {
        if (res.data) {
          console.log(res.data.productNo)
          if (null === res.data.productNo || "" === res.data.productNo || '' === res.data.productNo) {
            this.isSeting = false;
          }
          this.dataForm.productNo = res.data.productNo
          this.dataForm.uuid = res.data.uuid
        }
      })
    },
    onClickSubmit() {
      this.$refs['refForm'].validate((valid) => {
        if (valid) {
          this.dialogVisible = true
        }
      })
    },
    updateProductNo() {

      updateProductNo(this.dataForm.uuid, this.dataForm.productNo).then((res) => {
        this.dialogVisible = false
        this.$message({
          type: res.success ? "success" : "warning",
          message: res.success ? "设置成功" : "设置失败",
        })
      }).catch(err => {
        this.dialogVisible = false
      })
    },

  },
};
</script>

<style scoped lang="less">
/deep/ .el-dialog__body {
  overflow-y: auto !important;
  //height: 60vh !important;
  padding: 0px !important;
}

.product-no {
  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }
}

@media print {
  #nbprint {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    #2wm {
      right: 0;
    }

    #qrCode1Bg1 {
      //display: none;
      //visibility: hidden;
    }

    #qrCode2Bg2 {
      //display: none;
      //visibility: hidden;
    }
  }
}
</style>

<style media="print" scoped lang="less">
/*去除打印的页眉页脚*/
@page :left {
  margin-left: 0cm;
  padding-left: 0cm;
}

@page :right {
  margin-left: 0cm;
  padding-left: 0cm;
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceabilityOther/reversoProductNo.vue